import { Formik, FieldArray, Field } from "formik";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShopModel, ShopModelCreate } from "./Shop.model";
import { validationNew } from "./Shop.validation";
import {
  createShop,
  updateShop,
  updateBilling,
  updatePermission,
  createEnvVariable,
  updateEnvVariable,
} from "../../services/shop.service";
import Step1 from "./ShopStepper/Step1";
import { toast } from "react-hot-toast";

const initialState: ShopModelCreate = {
  id: 0,
  username: "",
  password: "",
  role: "",
  is_active: false,
  is_common: false,
  email: "",
  phone: "",
  name: "",
  number_of_order: -1,
  number_of_food: -1,
  number_of_category: -1,
  number_of_table: -1,
  is_trial: false,
  trial_day: 60,
};

const ShopCreate = (props: any) => {
  const [step, setStep] = useState(0);
  const [details, setDetails] = useState(initialState);
  const [billingId, setBillingId] = useState(0);
  const [shopId, setShopId] = useState(0);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("token") === "Admin") {
      if (props.location.details) {
        setDetails(props.location.details);
        setShopId(props?.location?.details?.id);
      }
    } else {
      props.history.push("/login");
    }
  }, []);

  const onBack = () => {
    if (step !== 0) {
      setStep(step - 1);
    }
  };

  const handleStepSubmit = async (value: ShopModelCreate) => {
    setLoader(true);
    if (step === 0) {
      const data = {
        id: value.id || 0,
        username: value.username,
        password: value.password,
        name: value.name,
        email: value.email,
        phone: value.phone,
        is_common: false,
        number_of_order: value.number_of_order,
        number_of_food: value.number_of_food,
        number_of_category: value.number_of_category,
        number_of_table: value.number_of_table,
        is_trial: value.is_trial,
        number_of_trail: value.trial_day,
      };
      if (data.id === 0) {
        try {
          const result = await createShop(data);
          if (result.status === 200) {
            setLoader(false);
            toast.success(result.data.message);
            setStep(1);
            setShopId(result.data?.data?.id);
            props.history.push("/shop");
          }
        } catch (err: any) {
          toast.error("Something went wrong, Please check username & email.");
        }
      } else {
        updateShop(data.id, data)
          .then((res: any) => {
            setLoader(false);
            toast.success(res.message);
            setStep(1);
          })
          .catch((err) => {
            setLoader(false);
            toast.error(err.message);
          });
      }
    }
  };

  const changeStep = (stepNo: any) => {
    setStep(stepNo);
  };

  return (
    <Formik
      onSubmit={(values) => handleStepSubmit(values)}
      enableReinitialize={true}
      initialValues={details}
      validate={(values) => {
        return validationNew(values, step);
      }}
    >
      {({
        handleSubmit,
        values,
        handleChange,
        errors,
        setFieldValue,
        touched,
      }) => (
        <>
          <form onSubmit={handleSubmit}>
            <div className="page-title clearfix">
              <button
                className="back-button mt-1"
                title="Back"
                onClick={() => props.history.push("/shop")}
              ></button>
              {step === 0 ? (
                <button
                  disabled={loader}
                  className="btn btn-primary primary-out"
                  type="submit"
                >
                  Create Shop
                </button>
              ) : null}
            </div>
            <div className="content-box ">
              <div className="content-body">
                <h1>Shop Info</h1>
                <div className="custom-scroll inner-body-wrapper">
                  <div className="scroller">
                    {step === 0 && (
                      <Step1
                        handleChange={handleChange}
                        errors={errors}
                        values={values}
                        touched={touched}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default ShopCreate;
